// Main App Component
import React from 'react';
import LandingPage from './components/LandingPage';
import './styles/globals.css';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App; 